import i18n from "@/i18n";

export const setAppLanguage = (lang = "en") => {
    i18n.changeLanguage(lang);
    localStorage.setItem("app_language",lang);

    document.documentElement.lang = lang;
    document.documentElement.dir = "ltr"; //lang === "ar" ? "rtl" : "ltr";
};